import { render, staticRenderFns } from "./languageView.vue?vue&type=template&id=41f1f6a2&"
import script from "./languageView.vue?vue&type=script&lang=js&"
export * from "./languageView.vue?vue&type=script&lang=js&"
import style0 from "./languageView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports